import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

import "@/App.css";

import Layout from "@/components/Layout/Layout";
import HomePage from "@/pages/HomePage";
import HowItWorksPage from "@/pages/HowItWorksPage";
import ForClinicsPage from "@/pages/ForClinicsPage";
import TechnologyPage from "@/pages/TechnologyPage";
import AboutPage from "@/pages/AboutPage";
import BlogPage from "@/pages/BlogPage";
import InvestorsPage from "@/pages/InvestorsPage";
import NotFoundPage from "@/pages/NotFoundPage";
import PrivacidadePage from "@/pages/PrivacidadePage";
import TermosPage from "@/pages/TermosPage";
import LGPDPage from "@/pages/LGPDPage";
import ConsentBanner from "@/components/ConsentBanner/ConsentBanner";
import AdminContactsPage from "@/pages/AdminContactsPage";

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/admin/contatos" element={<AdminContactsPage />} />
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/como-funciona" element={<HowItWorksPage />} />
          <Route path="/para-clinicas" element={<ForClinicsPage />} />
          <Route path="/tecnologia" element={<TechnologyPage />} />
          <Route path="/sobre" element={<AboutPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPage />} />
          <Route path="/investidores" element={<InvestorsPage />} />
          <Route path="/privacidade" element={<PrivacidadePage />} />
          <Route path="/termos" element={<TermosPage />} />
          <Route path="/lgpd" element={<LGPDPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </AnimatePresence>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AnimatedRoutes />
      <ConsentBanner />
    </BrowserRouter>
  );
}
